import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-link",
  "use": "icon-link-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"icon-link\"><path d=\"M1.354 9.425l7.07-7.071M3 1h7v7\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol